import axios from 'axios';
import config from '@/config';

let apiEndpoint = process.env.VUE_APP_API_BASEURL

export default {
    async postJob(data) {
        const payload = {
            billing_model: config.billing.jobBillingMode,
            ...data,
        };

        // If caller already set billing_model, keep it; otherwise fall back to env default
        if (data && data.billing_model) {
            payload.billing_model = data.billing_model;
        }

        return axios.post(`${apiEndpoint}/company/post-job`, payload, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('companyToken'),
            }
        });
    },
    async getJob(jobId) {
        return axios.get(`${apiEndpoint}/company/get-job/` + jobId, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('companyToken'),
            }
        });
    },
    async getRawJob(jobId) {
        return axios.get(`${apiEndpoint}/company/get-raw-job/` + jobId, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('companyToken'),
            }
        });
    },
    updateJob(data) {
        const payload = {
            billing_model: config.billing.jobBillingMode,
            ...data,
        };

        if (data && data.billing_model) {
            payload.billing_model = data.billing_model;
        }

        return axios.post(`${apiEndpoint}/company/update-job`, payload, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('companyToken'),
            }
        });
    },
    closeJob(jobUUID) {
        return axios.post(`${apiEndpoint}/company/close-job`, {
            jobUUID: jobUUID
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('companyToken'),
            }
        });
    },
    generateDraft() {
        return axios.get(`${apiEndpoint}/company/get-draft`, {
            params: {
                billing_model: config.billing.jobBillingMode
            },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('companyToken'),
            }
        });
    },
    updateDraft(step, draft, jobUUID, billingModel = null) {
        const payload = {
            step: step,
            draft: draft,
            jobUUID: jobUUID
        };

        if (billingModel) {
            payload.billing_model = billingModel;
        }

        return axios.post(`${apiEndpoint}/company/update-draft`, payload, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('companyToken'),
            }
        });
    },
    deleteDraft(jobUUID) {
        return axios.post(`${apiEndpoint}/company/delete-draft`, {
            jobUUID: jobUUID
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('companyToken'),
            }
        });
    },
    postJobWithCredit(data) {
        return axios.post(`${apiEndpoint}/company/post-job-with-credit`, data, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('companyToken'),
            }
        });
    }
}
